/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TextAlignCenterJustifyIcon20Regular = forwardRef('TextAlignCenterJustifyIcon20Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M3 3.25a.75.75 0 0 0 0 1.5h14a.75.75 0 0 0 0-1.5H3Z" }),
        React.createElement("path", { d: "M2.25 8A.75.75 0 0 1 3 7.25h14a.75.75 0 0 1 0 1.5H3A.75.75 0 0 1 2.25 8Z" }),
        React.createElement("path", { d: "M3 11.25a.75.75 0 0 0 0 1.5h14a.75.75 0 0 0 0-1.5H3Z" }),
        React.createElement("path", { d: "M3 15.25a.75.75 0 0 0 0 1.5h14a.75.75 0 0 0 0-1.5H3Z" })));
});
